// extracted by mini-css-extract-plugin
module.exports = {"fade":"fade-overlay_fade__4w4sj"};